export enum PatientTaskStatus {
    New = 1,
    InProgress = 2,
    Completed = 3,
    Hold = 4,
    Canceled = 5
}
